export default "__VITE_ASSET__bf2b1e97__"